import React, { useState } from 'react';
import { Divider, IconButton, Stack, Typography, Button } from '@mui/material';
import dayjs from 'dayjs';

import { Iconify, RHFTextField, RHFDatePicker } from '@app/components';
import { Strings } from '@app/constants';
import { StyledInputs } from '@app/modules/employees/view/styles';
import { IEducation } from '@app/modules/employees/types';

const initialEducation = {
  name: '',
  degree: '',
  passedOutYear: '',
  specialization: '',
};

interface props {
  onClose?: () => void;
  additionalButton?: React.ReactNode;
  secondaryPassedOutYear?: string;
  seniorSecodaryPassedOutYear?: string;
  graduationPassedOutYear?: string;
  graduation?: IEducation[];
  updateGraduationState?: (updatedEducations?: IEducation[]) => void;
  labelSuffix?: boolean;
}

const EducationsInfoForm = ({
  onClose,
  additionalButton,
  graduation,
  updateGraduationState,
  labelSuffix,
}: props) => {
  const [educations, setEducations] = useState(graduation ? graduation ?? [] : [initialEducation]);

  const renderInputFieldSets = () => {
    return educations?.map((education: IEducation, index: number) => (
      <>
        {index === 0 ? null : (
          <Stack alignItems={'flex-end'} pt={1}>
            <IconButton
              onClick={() => {
                handleRemoveClick(index);
              }}
              sx={{
                width: '3vw',
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <Iconify icon="material-symbols:close" />
            </IconButton>
          </Stack>
        )}
        <Stack gap={2} flexWrap={'wrap'} pt={1} mt={2}>
          <Stack direction={'row'} gap={2}>
            <RHFTextField
              name={`educationInfo.education[${index}].name`}
              type="text"
              label={Strings.education.schoolCollegeInstitute}
            />
            <RHFTextField
              name={`educationInfo.education[${index}].degree`}
              type="text"
              label={Strings.education.degreeDiplomaCertificate}
            />
          </Stack>
          <Stack direction={'row'} gap={2}>
            <RHFDatePicker
              name={`educationInfo.education[${index}].passedOutYear`}
              label={Strings.education.dateOfCompletion}
              sx={{ width: '50%' }}
              defaultValue={
                education.passedOutYear ? dayjs(education.passedOutYear, 'DD/MM/YYYY') : null
              }
            />
            <RHFTextField
              name={`educationInfo.education[${index}].specialization`}
              label={Strings.education.specialization}
            />
          </Stack>
        </Stack>
      </>
    ));
  };

  const handleAddMoreClick = () => {
    setEducations((prevEducations: any) => [...prevEducations, { ...initialEducation }]);
  };

  const handleRemoveClick = (index: number) => {
    const updatedEducations = educations?.filter((_, i) => i !== index);
    setEducations(updatedEducations);
    updateGraduationState?.(updatedEducations);
  };

  return (
    <Stack>
      <Stack pb={2}>
        <Typography variant="h5">{Strings.education.education}</Typography>
      </Stack>
      <Divider />

      <StyledInputs>
        {renderInputFieldSets()}
        <Stack flexDirection={'row'} justifyContent={'space-between'} mt={2}>
          <Stack>{additionalButton}</Stack>
          <Button
            variant="outlined"
            color="inherit"
            size="large"
            sx={{ width: 'max-content' }}
            onClick={handleAddMoreClick}
          >
            {Strings.button.addMore}
            <IconButton>
              <Iconify icon="ic:outline-plus" />
            </IconButton>
          </Button>
        </Stack>
      </StyledInputs>
    </Stack>
  );
};

export { EducationsInfoForm };
